module.exports = "<div id=\"boton-scroll\" (click)=\"subirScroll()\"><mat-icon class=\"icon\">arrow_upward</mat-icon></div>\n"